// extracted by mini-css-extract-plugin
export default {"cont":"Vienna_slide_cont__1nH3u","header":"Vienna_slide_header__ZrJOA","line":"Vienna_slide_line__IiVMp"};